
import { activateChat, activateSection, classicDomListeners, getDevPlayToken, getLaunchToken, hideSection, openHistoryUrl } from '@utils/helpers'
import { PlayerLaunch } from '@utils/types'
import { ScenesManager } from './ScenesManager'
import { state } from './state/AppState'
import { bustedFactor, multiplierFactor } from './Constants'

import $ from 'jquery';

import copy from 'copy-to-clipboard'
import { BetButtonState, BetStatus, ImoonCrash, isRtlLanguage, ModalButtonAction, parseToken } from '@alien-game-server/sdk'
import { App } from './App'
import { GameBaseClass } from '@alien-game-server/sdk/lib/game-base-class'
import { ModalButtonTypes, SdkModal } from '@game/SdkModal'
import { Layout } from '@rive-app/canvas'
import { ConfigManager } from './ConfigManager'
export let currentMultiplier = 0
export let elapsedTime = 0
const numberFormatter = new Intl.NumberFormat()
export class ClassicCrash {
    classicCrash!: ImoonCrash
    sdkModal = new SdkModal()
    configManager = new ConfigManager()
    classicDomListeners!: () => void
    token: string | undefined = undefined
    realityCheck: string | undefined = undefined


    nochat = false
    constructor() {
        // const token = this.getTokenFromURL()
        // this.token = token
        // this.classicCrash = new ImoonCrash({ token: this.token, gameId: '1008' });
        // this.classicDomListeners = () => classicDomListeners(classicCrash)
    }



    public lobbyButtonClicked(){
        App.gameLoad(true)
        this.classicCrash?.lobbyButtonClicked()
      }
      
      public homeButtonClicked(){
        App.gameLoad(true)
        this.classicCrash?.homeButtonClicked()
      }

    async buildClient() {
        let token = this.getTokenFromURL() ?? ""
        const isStage = process.env.ENV_ID == "stage" || process.env.ENV_ID == "dev"
        if (!token && isStage) token = await getDevPlayToken('1008')
        this.token = token
        this.classicCrash = new ImoonCrash({ token: this.token,  baseUrl: process.env.LOCAL_BASE || undefined });
 
        this.classicDomListeners = () => classicDomListeners(classicCrash)
        // this.isRTL = isRtlLanguage(this.getLanguage())
    }


    //get token then start listeners
    async start(sceneManager: ScenesManager) {

        //crashroyal listeners
        this.startListeners(sceneManager)
        this.classicDomListeners()

    }


    translate(value:string){
        return this.classicCrash.translate(value)
    }


    getTokenFromURL(): string | undefined {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        return decodeURIComponent(token || '')
    }

    async connect() {
        try {
            await this.classicCrash.connect()
            const isRTL = isRtlLanguage(this.getLanguage())
            const nicknameModal = document.getElementById('nickname-modal') as HTMLDivElement
            if (this.isRTL()) {
                document.body.classList.add('font_rtl')
                nicknameModal.classList.add('isRTL')
            }
        } catch (error) {
            console.error("error connecting", error)
        }

    }



     

    public UILogs(data: any) {
        this.classicCrash?.logDeviceInfo(data)
    }

    isRTL() {
        return isRtlLanguage(this.getLanguage())
    }
    getLanguage() {
        if (this.token) return parseToken(this.token).language ?? "en"
        else {
            const urlParams = new URLSearchParams(window.location.search);
            return (urlParams.get('lang') || urlParams.get('language')) ?? "en";
        }

    }



    startListeners(sceneManager: ScenesManager) {

        const cashoutValue = document.getElementById('cashout-value-count') as HTMLSpanElement


        this.classicCrash.onGameConfigUpdated(async (data) => {
            // console.log('@CLASSIC onGameIsReady')
            // show app
                    
      
            const waiElements = document.querySelectorAll('[data-wait]') //show app
            const loader = document.getElementById('loader')
            setTimeout(() => {
                App.splashManager.hideLoader() //hide loader

                waiElements.forEach(el => {
                    el.classList.add('show') //show app elements
                })
            }, 1000)

             this.configManager.modalHandler.setRealityCheckData(data.realityCheckData)
             this.configManager!.modalHandler.showHome = data.homeButtonIsVisible
             this.configManager!.modalHandler.showLobby = data.showLobby

            //translate2 elements 

            //user result translation
            document.getElementById('user-header-user')!.innerHTML = `${this.translate('userLabel')}`
            document.getElementById('user-header-bet')!.innerHTML = `${this.translate('betLabel')}`
            document.getElementById('user-header-profit')!.innerHTML = `${this.translate('profitLabel')}`

            document.getElementById('user-header-user-mobile')!.innerHTML = `${this.translate('userLabel')}`
            document.getElementById('user-header-bet-mobile')!.innerHTML = `${this.translate('betLabel')}`
            document.getElementById('user-header-profit-mobile')!.innerHTML = `${this.translate('profitLabel')}`
            //history translation

            //notice text translation
            document.getElementById('notice-text')!.innerHTML = `${this.translate('importantNotice')}`
            //exit button translation
            document.getElementById('exit-btn')!.innerHTML = `${this.translate('exitLabel')}`
            //bet panel translation
            document.getElementById('bet-component-header')!.innerHTML = `${this.translate('betPanelLabel')}`
            document.getElementById('amount-text-placeholder')!.innerHTML = `${this.translate('historyBetAmountLabel')}`
            document.getElementById('auto-cahsout-placeholder')!.innerHTML = `${this.translate('autoCashoutLabel')}`
            //tabs translation
            document.getElementById('history-tab-text')!.innerHTML = `${this.translate('historyTitle')}`
            document.getElementById('chat-tab-text')!.innerHTML = `${this.translate('chatTitle')}`
            document.getElementById('players-tab-text')!.innerHTML = `${this.translate('menuPlayersLabel')}`
            //translate2 nickname
            document.getElementById('nickname-placeholder')!.innerHTML = `${this.translate('nicknameModalTitle')}`
            document.getElementById('nickname-button')!.innerHTML = `${this.translate('nicknameBtn')}`
            //history header title 
             document.getElementById('history-header-title')!.innerHTML = `${this.translate('historyTitle')}`
            //translate2 details  details-title
            document.getElementById('details-title')!.innerHTML = `${this.translate('historyBetDetailsTitle')}`
            //input placeholder
            const input = document.getElementById('amount-value') as HTMLInputElement
            input.placeholder = classicCrash.translate('enterBetAmountLabel')

            //   handle nickname modal
            const nicknameModal = document.getElementById('nickname-modal') as HTMLDivElement
            const nickName = data?.nickname
            if (!nickName) {
                nicknameModal.classList.remove('hide')
            } else {
                const nickNameContent = document.getElementById('nickname') as HTMLParagraphElement
                nickNameContent.innerHTML = nickName
            }
            const url = new URL(window.location.href)
            // let noAlert = url.searchParams.get('noalert')
            // if (noAlert === 'true') {
            //     const notice = document.getElementById('notice') as HTMLDivElement
            //     notice.classList.add('hide')

            // }


            // for test 
            //     this.sdkModal.show()
            //     this.sdkModal.setButtons([
            //     {action:ModalButtonAction.BACK_TO_HOME,
            //       isPrimaryButton:true,
            //       title:'Return To Main',
            //       titleAfterClick:'Redirect...'
            //     },
            //     {action:ModalButtonAction.CLOSE_MODAL,
            //       isPrimaryButton:false,
            //       title:'Close',
            //       titleAfterClick:''
            //     },
            //   ])
            //  this.sdkModal.setTitle("Disconnected","Go Back Mome")


// setTimeout(()=>{

//               this.sdkModal.show();

//               this.sdkModal.setHeaderIcon("history", ()=>{
//                     if(1){
                       
//                           document.body.classList.add('rc')
                     
//                     //   openHistoryUrl(data.historyUrl)
//                     }else{
//                     //   App.emitter.emit(App.config.events.OPEN_HISTORY)
                     
//                         document.body.classList.add('rc')
                      
//                     }
//               })


//               this.sdkModal.setButtons([ 
//                 {action:ModalButtonAction.CLOSE_MODAL,
//                     isPrimaryButton:true,
//                     title: this.translate("continueLabel"),
//                     titleAfterClick: this.translate("continueLabel")
//                   },
//                   {action:ModalButtonAction.BACK_TO_HOME,
//                     isPrimaryButton:false,
//                     title: this.translate("exitLabel"),
//                     titleAfterClick: this.translate("exitLabel")
//                   }]
//               );
//             this.sdkModal.setTitle(this.translate("realityCheckTitle"), this.translate("realityCheckDescription").replace("{{realityCheckIntervalMinutes}}", 11..toString()));
// },5000)


            const tournamentData = await this.classicCrash.getTournamentStat()
            if (tournamentData) {
                const topWinners = document.getElementById('top-winners') as HTMLDivElement
                topWinners.innerHTML = `<p>${this.translate('topWinnerLabel')}</p>`
                tournamentData?.winners.slice(0, 3).forEach(el => {
                    topWinners.innerHTML += `<p>${numberFormatter.format(el.winOdds)} @${el.prize} ${el.nickname}</p>`
                })
            }


            // const noChat = url.searchParams.get('nochat')

            // if (noChat === 'true') {
            //     this.nochat = true
            //     const chatContent = document.getElementById('chat-content') as HTMLDivElement
            //     const chatTab = document.getElementById('chat-tab') as HTMLButtonElement
            //     const historyContent = document.getElementById('history-content') as HTMLDivElement

            //     chatContent.classList.add('hide')
            //     chatTab.classList.add('hide')

            //     historyContent.classList.remove('hide')
            // }



        })

        this.classicCrash.onInsufficientFunds(async ()=>{
            App.configManager!.modalHandler.showInsufficiantFunds({condition:true})
          })
        this.classicCrash.onDisconnected(async (data)=>{
            App.configManager!.modalHandler.showModal(data.reason)
          })

        this.classicCrash.onCountdownUpdated(async data => {

            const nextRoundEl = document.getElementById('next-round') as HTMLParagraphElement
            if (!state.getState().isWait) {

                state.setState({ ...state.getState(), isWait: true })
                //stop the scene and reset
                sceneManager.scene?.stop()

                //show nextround

                nextRoundEl?.classList.remove('hide')

                //hide multiplier nad return fontsize
                const multiplier = document.getElementById('multiplier') as HTMLParagraphElement
                multiplier.innerHTML = ''
                multiplier.classList.add('hide')

                const canvasComponent = document.querySelector('#canvas canvas') as HTMLCanvasElement
                const canvasWidth = canvasComponent.clientWidth
                const fontSize = canvasWidth / multiplierFactor
                multiplier.style.fontSize = `${fontSize}px`

                data.countdownValue

            }
            nextRoundEl.innerHTML = data.formattedCountdownValue

        })

        this.classicCrash.onIdleAlert( async (params) =>{
            App.configManager?.modalHandler.showIdleModal(params.durationInMs)
          })


        this.classicCrash.onNewMultiplier(async data => {
            // console.log('@CLASSIC onMultiplierUpdated',data)
            if (!state.getState().isMultiplier) {

                state.setState({ ...state.getState(), isWait: false }) //return it to false
                const nextRoundEl = document.getElementById('next-round') as HTMLParagraphElement
                nextRoundEl.classList.add('hide') //those to be deleted
                //show multiplier if not shown 
                sceneManager.scene?.update()
                const multiplier = document.getElementById('multiplier') as HTMLParagraphElement
                multiplier.classList.remove('text-red')
                multiplier.classList.remove('hide')
                state.setState({ ...state.getState(), isMultiplier: true })


            }
            currentMultiplier = data.currentMultiplier
            //elapsed time
            // elapsedTime = data.elapsedTimeFromStart
            elapsedTime = data.elapsedTimeFromStart
            //    console.log('ELAPSED TIME',data.elapsedTimeFromStart)
            //    console.log('MULTIPLIER',data.formattedCurrentMultiplier)
            const multiplier = document.getElementById('multiplier') as HTMLParagraphElement
            multiplier!.innerHTML = `${data.formattedCurrentMultiplier}`
            //update the scene
        })

        this.classicCrash.onBetButtonUpdated(async data => {


            const activityBtn = document.getElementById('activity-button') as HTMLButtonElement
            if (!activityBtn) return
            // activityBtn.innerHTML = `${data.title}`
            if (!data.isValid) {
                activityBtn.classList.add('disabled')
                activityBtn.setAttribute('disabled', 'true')
            } else {
                activityBtn.classList.remove('disabled')
                activityBtn.removeAttribute('disabled')
            }
            switch (data.state) {
                case BetButtonState.BET: {

                    //control the activity button classes
                    activityBtn.classList.remove('cancel-button', 'next-round', 'cashout-button')
                    activityBtn.classList.add('placebet-button')
                    activityBtn.innerHTML = `${data.title}`
                    document.getElementById('multiplier')?.classList.remove('green')
                    //enable control panel
                    document.getElementById('bet-component')?.classList.remove('disabled')
                    //set curve normal
                    //set curve green
                    state.setState({ ...state.getState(), isCurveGreen: false })


                    break;
                }
                case BetButtonState.CANCEL: {

                    //control the activity button classes
                    activityBtn.classList.remove('placebet-button', 'next-round', 'cashout-button', 'nextround')
                    activityBtn.classList.add('cancel-button')
                    activityBtn.innerHTML = `${data.title}`
                    // if (data.subTitle) {
                    //     activityBtn.classList.add('nextround')
                    //     activityBtn.innerHTML = `<span>${this.translate(TranslationsKey.btnCancel)}</span> <span>${data.subTitle}</span>`
                    // } else {
                    //     activityBtn.classList.remove('nextround')
                    //     activityBtn.innerHTML = `${data.title}`
                    // }

                    document.getElementById('multiplier')?.classList.remove('green')
                    //disable control panel - since bet is placed 
                    document.getElementById('bet-component')?.classList.add('disabled')

                    break;
                }
                case BetButtonState.CASHOUT: {
                    if (!state.getState().cashingOut) {
                        state.setState({ ...state.getState(), cashingOut: true })
                        //better to implement the chashout  logic here -- TODO
                        state.setState({ ...state.getState(), cashingOut: true })
                        //control the activity button classes
                        activityBtn.classList.remove('placebet-button', 'next-round', 'cancel-button', 'nextround')
                        activityBtn.classList.add('cashout-button')
                        activityBtn.innerHTML = `<span id="cashout-title">${data.title}</span>`
                        //make multiplier green
                        document.getElementById('multiplier')?.classList.add('green')
                        //set curve green
                        state.setState({ ...state.getState(), isCurveGreen: true })

                    }

                    // document.getElementById('cashout-value-counter')!.innerHTML = data.title
                    const cashoutTitle = document.getElementById('cashout-title') as HTMLSpanElement
                    if (cashoutTitle) {
                        cashoutTitle.innerHTML = data.title
                    }


                    break;

                }

                case BetButtonState.PENDING: {
                    activityBtn.innerHTML = `${data.title}`

                }
                default: {
                    // console.log('invalid button')
                }
            }
        })

        this.classicCrash.onCrash(async data => {

            currentMultiplier = 0
            //reset cashingOut 
            state.setState({ ...state.getState(), cashingOut: false })
            //reset cashout value
            document.getElementById('cashout-value')!.innerHTML = ``
            //reset cashingout for next cashout 
            state.setState({ ...state.getState(), cashingOut: false }) // for next cashout round
            state.setState({ ...state.getState(), isMultiplier: false }) // tobe deleted
            // console.log("@CLASSIC onCrash", data)
            //reset elapsed time 
            elapsedTime = 0
            //decrease fontsize for multiplier
            const multiplier = document.getElementById('multiplier') as HTMLParagraphElement
            multiplier.classList.add('text-red')
            // multiplier.innerHTML = `${data.title} <br/>${data.formattedCrashPoint}`
            multiplier.innerHTML = `${data.formattedCrashMultiplier}`
            //pause the scene
            sceneManager.scene?.pause()
            //get player history
            // await this.crashClient.getPlayerHistory({})
        })


        this.classicCrash.onNewRound(async data => {
            // console.log('@CLASSIC onNewRound', data)
            const tournamentData = await this.classicCrash.getTournamentStat()
            if (tournamentData) {
                const topWinners = document.getElementById('top-winners') as HTMLDivElement
                topWinners.innerHTML = `<p>${this.translate('topWinnerLabel')}</p>`
                tournamentData?.winners.slice(0, 3).forEach(el => {
                    topWinners.innerHTML += `<p>${numberFormatter.format(el.winOdds)} @${el.prize} ${el.nickname}</p>`
                })
            }
        })


        this.classicCrash.onInputBetAmountUpdated(async data => {

            const halveBtn = document.getElementById('halve-btn') as HTMLSpanElement
            const doubleBtn = document.getElementById('double-btn') as HTMLSpanElement
            const input = document.getElementById('amount-value') as HTMLInputElement
            const container = document.querySelector('#amount-component > div')
            //if invalid value use invalid class
            if (!data.isValid) {
                //disable amount input 
                container?.classList.add('inValid')
            }
            else {
                container?.classList.remove('inValid')
            }
            //add currency
            const currency = document.getElementById('currency') as HTMLSpanElement
            currency.innerHTML = `${data?.currency}`
            //add value
            const value = data.inputBetAmount
            input.value = value

            //enable disable change btns
            if (data.doubleButtonIsEnabled) {
                doubleBtn.classList.remove('disabled')
            } else {
                doubleBtn.classList.add('disabled')
            }
            if (data.halveButtonIsEnabled) {
                halveBtn.classList.remove('disabled')
            } else {
                halveBtn.classList.add('disabled')
            }
        })

        const container = document.querySelector('#cashout-component > div')
        this.classicCrash.onAutoCashoutUpdated(async data => {
            // console.log("@@@autoCahsoutUpdated", data)
            const slider = $('#cashout-input') as any
            const currentSliderValue = slider.val()
            const cashoutValueTextInput = document.getElementById('cashout-value') as HTMLInputElement
            if (+currentSliderValue !== +data.autoCashoutMultiplier) {

                slider.val(data.autoCashoutMultiplier).change()
            }
            const value = data.formattedAutoCashoutMultiplier;
            cashoutValueTextInput.value = value


        })

        this.classicCrash.onBalanceUpdated(async data => {
            // console.log("@CLASSIC onBalanceUpdated", data)
            const balance = document.getElementById('profit') as HTMLSpanElement
            balance.innerHTML = `${data?.formattedBalance ?? ''}`
            const currency = document.getElementById('currency') as HTMLSpanElement
            // currency.innerHTML = `${data?.currency}`

        })


        this.classicCrash.onRealtimeUpdated(async (data) => {
            // console.log("@CLASSIC onRealtimeUpdated", data)
            // console.log("onCurrentRoundBetList", data)
            //add players to players container
            const wideScreePlayerContainer = document.getElementById('players-container-wide') as HTMLDivElement
            wideScreePlayerContainer.innerHTML = '' //reset each time

            data?.realtimeData.forEach(player => {
                const className = player.betStatus === BetStatus.OPEN ? 'orange' :
                    player.betStatus === BetStatus.LOST ? 'red' :
                        player.betStatus === BetStatus.WON ? 'green' :
                            ''
                const winOdds = player.formattedWinOdds
                wideScreePlayerContainer.innerHTML += `
                                <div class="player-item ${className}">
                                    <span class="player-item-name-wrapper"><span class="player-item-name">${player.nickname}</span> </span>
                                    <span>${winOdds || '-'}</span>
                                    <span>${player.formattedBetAmount || '-'}</span>
                                    <span>${player.formattedProfit || '-'}</span>
                                </div>
                    `
            })

            const playersNumber = data.realtimeData.length || 0
            const playersProgressBar = document.getElementById('players-wide-progress') as HTMLDivElement
            //empty the progress bar
            playersProgressBar.innerHTML = ''
            const progressBlockWidth = playersProgressBar.clientWidth / playersNumber
            //loop to add blocks
            data.realtimeData.forEach(player => {
                const backgroundColor = player.betStatus === BetStatus.OPEN ? 'orange' :
                    player.betStatus === BetStatus.LOST ? 'red' :
                        player.betStatus === BetStatus.WON ? 'green' :
                            ''
                const blockDiv = document.createElement('div')
                blockDiv.style.width = `${progressBlockWidth}px`
                blockDiv.style.height = '100%'
                blockDiv.style.backgroundColor = backgroundColor
                playersProgressBar.appendChild(blockDiv)
            })
            const playersContainer = document.getElementById('players-container') as HTMLDivElement
            playersContainer.innerHTML = '' //reset each time
            data.realtimeData.forEach(player => {
                const className = player.betStatus === BetStatus.OPEN ? 'orange' :
                    player.betStatus === BetStatus.LOST ? 'red' :
                        player.betStatus === BetStatus.WON ? 'green' :
                            ''
                const winOdds = !!player.formattedWinOdds && (+player.formattedWinOdds >= 20 ? '∞' : player.formattedWinOdds)
                playersContainer.innerHTML += `
                                <div class="player-item ${className}">
                                    <span class="player-item-name-wrapper"><span class="player-item-name">${player.nickname}</span> </span>
                                    <span>${winOdds || '-'}</span>
                                    <span>${player.formattedBetAmount || '-'}</span>
                                    <span>${player.formattedProfit || '-'}</span>
                                </div>
                    `
            })


        })









        this.classicCrash.onBetRoundHistoryUpdated(async data => {

            const content = document.getElementById('history-wrapper') as HTMLDivElement
            const detailsOverlay = document.getElementById('history-details-overlay') as HTMLDivElement
            const detailsWrapper = document.getElementById('details-wrapper') as HTMLDivElement
            content.innerHTML = ''
            // console.log("$$$onBetRoundHistoryUpdated", data)
            if (!data.betRoundHistory.length) return
            data.betRoundHistory.forEach(item => {
                const element = document.createElement('div')

                if (item.playingDetails) {
                    element.classList.add('is-player')
                }
                element.classList.add('historyItem')
                // element.innerHTML = ` ${item.formattedCrashPoint || ''}`
                element.innerHTML = item.playingDetails?.status === BetStatus.OPEN ? (item.playingDetails?.formattedStatus ?? '') : `${item.formattedCrashMultiplier ?? '-'}`
                let className = ''
                let baageStatusClass = ''

                switch (item.playingDetails?.status) {
                    case BetStatus.OPEN: {
                        className = 'open'
                        baageStatusClass = 'open'

                        break;
                    }

                    case BetStatus.WON: {
                        className = 'won'
                        baageStatusClass = 'won'

                        break;
                    }
                    case BetStatus.LOST: {
                        className = 'lost'
                        baageStatusClass = 'lost'
                        break
                    }
                    case BetStatus.CASHBACK: {
                        className = 'cashout'
                        baageStatusClass = 'cashout'
                        break;
                    }

                    case BetStatus.CANCELED: {
                        className = 'cancel'
                        baageStatusClass = 'cancel'
                        break;

                    }
                    default: {
                        className = 'default'
                    }
                }


                element.classList.add(className)
                content.appendChild(element)
                element.onclick = () => {
                    detailsOverlay.classList.remove('hide')
                    // console.log("MULTIPLIER_WIN_ODDS",item.playingDetails?.formattedWinOdds)

                    detailsWrapper.innerHTML = `
            <div id="details-general">
      <div id="details-general-wrapper">
        ${item.playingDetails?.formattedStatus ? `<div class="details-item">
              <span class="details-item-title" data-text>${this.translate('historyBetStatusTitle')}</span>
              <div class="status-badge ${baageStatusClass}">
          
                  <span class="details-badge-result ">${item.playingDetails?.formattedStatus ?? '-'}</span>
              </div>
          </div>` : ''
                        }  
          <div class="details-item">
              <span class="details-item-title" data-text>${this.translate('historyDateTimeLabel')}</span>
              <span dir=${'ltr'} class="details-item-value" >${item.playingDetails?.formattedPlacedAt ?? item.formattedCrashAt}</span>
          </div>
          <div class="details-item">
              <span class="details-item-title" data-text>${this.translate('historyBetAmountLabel')}</span>
              <span class="details-item-value" >${item.playingDetails?.formattedBetAmount ?? '-'}</span>
          </div>
          <div class="details-item">
              <span class="details-item-title" data-text>${this.translate('roundIdLabel')}</span>
              <span class="details-item-value details-round-copy" dir="ltr">
              <span>${item?.roundIndex}</span>
              <span>   <img id="details-round-copy" title="Copy" class="copy-round" data-round="${item?.roundIndex}" src="./assets-${process.env.ASSETS_VERSION}/copyBtn.png"  /></span>
              </span>
          </div>
          <div class="details-item">
              <span class="details-item-title" data-text>${this.translate('historyOddsLabel')}</span>
              <span class="details-item-value">${item.playingDetails?.formattedWinOdds ?? '-'}</span>
           
          </div>
       
          <div class="details-item">
              <span class="details-item-title" data-text>${this.translate('historyWinAmountLabel')}</span>
              <span class="details-item-value ${item.playingDetails?.status === BetStatus.WON && "won"}"}">${item.playingDetails?.formattedWinAmount ?? '-'}</span>
          </div>
             <div class="details-item">
              <span class="details-item-title" data-text>${this.translate('crashPointLabel')}</span>
              <span class="details-item-value ${item.playingDetails?.status === BetStatus.LOST && "lost"}">${item?.formattedCrashMultiplier ?? ''}</span>
          </div>
        
      </div>
  </div>`

                    const roundElement = document.getElementById('details-round-copy') as HTMLImageElement
                    roundElement.addEventListener('click', () => {
                        copy(`${item?.roundIndex}`)
                        roundElement.src = `./assets-${process.env.ASSETS_VERSION}/check.png`
                        roundElement.title = 'Copied'
                        setTimeout(() => {
                            roundElement.src = `./assets-${process.env.ASSETS_VERSION}/copyBtn.png`;
                            roundElement.title = 'Copy'
                        }, 2000)
                    })
                }

            })
        })



        this.classicCrash.onBetResultReceived(async data => {
            // console.log("^^^onBetResultReceived", data)

            const betStatus = data.betStatus
            if (betStatus === BetStatus.WON) {
                document.getElementById('multiplier')?.classList.remove('green')
                state.setState({ ...state.getState(), isCurveGreen: false })
            }

        })

        this.classicCrash.onChatStatusUpdated(async params => {
            const chatBlock = document.getElementById('message-block') as HTMLDivElement
            const messageInput = document.getElementById('message-input-wrapper') as HTMLDivElement
            const messageTitle = document.getElementById('message-block-title') as HTMLParagraphElement
            App.configManager?.setmaxMessageLength(params.maxMessageLength)
            if (params.isChatEnabled) {
                chatBlock.classList.add('hide')
                messageInput.classList.remove('hide')

                activateChat()
            } else {
                chatBlock.classList.remove('hide')
                messageInput.classList.add('hide')
                messageTitle.innerText = params.message || ''
                if (params.hideChatIfDisabled) {
                    hideSection('chat')
                    activateSection('history')
                }

            }

            if (params.hideChatAlert) {
                const notice = document.getElementById('notice') as HTMLDivElement
                notice.classList.add('hide')
            }
        })


        this.classicCrash.onModalDisplayed(async data => {
            this.sdkModal?.show();
            this.sdkModal?.setTitle(data.title, data.description);

            
           this.sdkModal?.setButtons(data.buttons.map(button=>({
                type: button.isPrimaryButton ? ModalButtonTypes.primary : ModalButtonTypes.secondary,
                action: button.action,
                title: button.title,
              })));

        })


        this.classicCrash.onChatMessageReceived(async data => {
            //  console.log("@@@CHAT", data)
            const messageContainer = document.getElementById('messages-container') as HTMLDivElement
            if (Array.isArray(data)) {
                data.forEach(item => {
                    messageContainer.innerHTML += `
                    <div class="message">
                        <p class="message-name">
                            ${item.sender}
                        </p>
                        <p class="message-content">
                            ${item.messageText}
                        </p>
                    </div>
                 `
                })
            } else {
                messageContainer.innerHTML += `
                <div class="message">
                    <p class="message-name">
                        ${data.sender}
                    </p>
                    <p class="message-content">
                        ${data.messageText}
                    </p>
                </div>
             `
            }


            // Scroll to the bottom
            messageContainer.style.scrollBehavior = 'auto';
            messageContainer.scrollTo({ top: messageContainer.scrollHeight, behavior: 'auto' })
        })

        this.classicCrash.onClearChatMessages(async () => {
            const messageContainer = document.getElementById('messages-container') as HTMLDivElement
            const messages = messageContainer.querySelectorAll(".message") as NodeListOf<HTMLElement>
            messages.forEach(message => {
                message.remove()
            })

        })




        // this.classicCrash.onTopWinnersUpdated(async data => {
        //     // console.log("onUpdateTopWinners", data)
        //     const topWinners = document.getElementById('top-winners') as HTMLDivElement
        //     topWinners.innerHTML = `<p>${this.translate(TranslationsKey.canvasTopWinners)}</p>`
        //     data.forEach(el => {
        //         topWinners.innerHTML += `<p>${numberFormatter.format(el.winOdds)} @${el.prize} ${el.nickname}</p>`
        //     })
        // })

        this.classicCrash.onNicknameUpdated(async data => {
            if (!data.success) return
            const nickname = document.getElementById('nickname') as HTMLParagraphElement
            nickname.innerHTML = `${data.nickname}`
            const nicknameModal = document.getElementById('nickname-modal') as HTMLDivElement
            nicknameModal.classList.add('hide')
        })

    }
}

export const classicCrash = new ClassicCrash()


